<template>
  <el-tree
    :data="data"
    :props="defaultProps"
    :expand-on-click-node="true"
    :render-content="showBtn?renderContent:renderContent1"
    :show-checkbox="check"
    :default-expand-all="expandAll"
    :default-expanded-keys="expandKey"
    node-key="id"
    accordion
    ref="tree"
    @check-change="handleCheckChange"
    @node-click="handleClick">
  </el-tree>
</template>
<script>
import {Tree, Button} from 'element-ui'
export default {
  name:'treeBox',
  props:{
    check:{
      type:Boolean,
      default: false
    },
    data:{
      type:Array,
      default(){
        return []
      }
    },
    expandAll:{
      type:Boolean,
      default:false,//默认展开所有节点
    },
    expandKey:{
      type:Array,
      default:()=>{
        return [];
      }
    },
    // 显示操作按钮
    showBtn:{
      type: Boolean,
      default: true
    }
  },
  data(){
    return{
      
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    
    }
  },
  methods:{
    // this.$refs.tree.currentNode.$el
    append(node,data) {
      this.$emit('appendEvent',node,data);
      // const newChild = { id: id++, label: '新建标签', children: [] };
      // if (!data.children) {
      //   this.$set(data, 'children', []);
      // }
      // data.children.push(newChild);
    },

    remove(node, data) {
      this.$emit('removeEvent',node,data);
      // const parent = node.parent;
      // const children = parent.data.children || parent.data;
      // const index = children.findIndex(d => d.id === data.id);
      // children.splice(index, 1);
    },

    edit(e,node,data){
      e.stopPropagation()
      this.$emit('editEvent',e,node,data);
    },

    updata(e,node,data){
      this.$emit('updataEvent',e,node,data);
    },

    enter(e,node,data){
      if( e.keyCode === 13 ){
        e.target.blur();
      }
    },

    handleCheckChange(data, checked, indeterminate){
      // console.log(data, checked, indeterminate)
    },
    handleClick(data, node){
      this.$emit('click',data,node)
      // console.log(data, node)
    },

    renderContent(h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px; width: calc(100% - 66px);overflow: hidden;">
          <span style="width:100%;max-width:100%;overflow:hidden">
            <span style="width: 100%;text-overflow: ellipsis;overflow: hidden;display: inline-block;" 
              class={data.act?'act':''}
              title={node.label}>{node.label}</span>
            <input type="text" value={node.label} style="maxWidth:80px;display:none" on-blur={ e => this.updata(e,node, data) } on-keyup={e=>this.enter(e,node,data)}></input>
          </span>
          <span class="tree-btn">
            <a href="javascript:;" class="btn" type="text" on-click={ () => this.append(node, data) }>
              <i class="el-icon-circle-plus-outline"></i>
            </a>
            <a href="javascript:;" class="btn" type="text" on-click={ e => this.edit(e,node, data) }>
              <i class="el-icon-edit"></i>
            </a>
            <a href="javascript:;" class="btn" type="text" on-click={ () => this.remove(node, data) }>
              <i class="el-icon-delete col-red"></i>
            </a>
          </span>
        </span>);
    },
    renderContent1(h, { node, data, store }) {
      return (
        <span style="flex: 1; display: flex; align-items: center; justify-content: space-between; font-size: 14px; padding-right: 8px;">
          <span>
            <span class={data.act?'act':''}>{node.label}</span>
            <input type="text" value={node.label} style="maxWidth:80px;display:none" on-blur={ e => this.updata(e,node, data) } on-keyup={e=>this.enter(e,node,data)}></input>
          </span>
        </span>);
    }
  },
  components:{
    elTree:Tree,
    elButton:Button
  },
}
</script>
<style>
.tree-btn a.btn{
  font-size: 12px;
  color: #409EFF;
  margin-left: 10px;
}
.tree-btn .btn:hover{
  opacity: 0.8;
}
.act{
  color: #409EFF;
}
</style>


// WEBPACK FOOTER //
// src/components/treeBox.vue